<template>
    <e-charts
        ref="lineChart"
        autoresize
        :options="line"
        theme="theme-color"
        auto-resize
        @click="$emit('click', $event)"
    />
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/chart/line'
import theme from './theme.json'

ECharts.registerTheme('theme-color', theme)

export default {
  components: {
    ECharts,
  },
  props: {
    optionData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      line: {

        // Make gradient line here
        visualMap: [{
          type: 'piecewise',
        }],
        grid: {
          width: '94.4%',
          height: '96%',
          left: '29px',
          top: '6x',
        },
        tooltip: {
          formatter: "Tempo: {b} <br/> {a}: {c}"
        },
        xAxis: [{
          title: 'Tempo',
          boundaryGap: false,
          data: this.optionData.xAxisData,
        }],
        yAxis: {
          boundaryGap: false,
          type: 'value',
          label: 'Tempo',
        },
        series: {
          name: 'Audiência ',
          type: 'line',
          showSymbol: true,

          areaStyle: {
            color: '#20e64a',
            opacity: 0.5
          },

          data: this.optionData.series,
        },
      },
    }
  },
  computed: {
    getEChart() {
      return this.$refs.lineChart
    }
  },
  methods: {
    teste() {

    }
  }
}
</script>

<style>

</style>
